import { requester } from "@module/_core/infras/config/request/requester";
import { appRequest } from "@module/_core/infras/config/request/axios";
import { HomeEndpoint } from "@module/home/infras/config/endpointUrl";
import { GetOnePlanDTO, GetPlansDTO, PlanDTO } from "../dto/home";

export class PlanApi {
    static async getPlans() {
        return requester<PlanDTO[]>({
            requestFunc: () => appRequest.mapServer.get(HomeEndpoint.getPlans()),
            handleData: (data: GetPlansDTO) => data.data
        })();
    }

    static async getDetailPlan(planId: number) {
        return requester<{ plan: PlanDTO }>({
            requestFunc: () => appRequest.mapServer.get(HomeEndpoint.getDetailPlan(planId)),
            handleData: (data: GetOnePlanDTO) => data.data
        })();
    }
}
